<template>
    <div class="page-wrapper page-fixed switchAccounts-wrapper" v-if="showCard">
        <div class="movie-box page-text-center page-background-color-white title">
            选择专区
            <span class="page-absolute cancel" @click="cancel">×</span>
        </div>
        <div class="movie-wrapper page-relative wp">
            <ul class="movie-box switchAccounts-list-wrapper">
                <li v-for="(item, ind) in cardList" :key="ind" @click="checkedCard(item)" class="movie-box page-background-color-white page-margin-bottom2 acea-row row-middle page-relative switchAccounts-list">
                    <img class="account-img" :src="item.imgUrl || require('@/assets/images/defaultbgd.png')" />
                    <div class="page-flex-1 acea-row row-column-around account-right">
                        <span class="font-size24" v-if="item.type == '1'">
                            <span class="font-size36 font-weight650 colorF6433D">{{item.all_price}}</span>点余额
                        </span>
                        <span class="font-size24" v-if="item.type == '2'">
                            <span class="font-size36 font-weight650 colorF6433D">{{item.all_price}}</span>次可兑换
                        </span>
                        <span class="font-size24">绑定卡券{{item.cardNum || 0}}张</span>
                    </div>
                    <div class="page-absolute page-text-center colorWhite bgdF6433D yes-img">
                        <span>选择专区</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "SwitchAccounts",
    props: {
        showCard: {
            type: Boolean,
            default: false
        },
        cardList: {
            type: Array,
            default: ()=>[]
        },
        title: {
            type: String,
            default: ""
        }
    },
    watch: {
        title: function (newVal) {
            this.checkedId = newVal;
        }
    },
    data: function () {
        return {
            // cardList: [
            //     {
                    // id: ,
                    // cate_name: ,
                    // imgUrl: ,
                    // type: ,
                    // title
            //     }
            // ],
            checkedId: null, //选中卡券
        }
    },
    methods: {
        cancel() {
            this.$emit('cancel', false);
        },
        checkedCard: function (val) {
            this.$dialog.confirm({
                mes: `确定选择此专区吗？`,
                opts: ()=>{
                    this.checkedId = val.title;
                    let data = {
                        id: val.id,
                        showCard: false,
                        title: val.title,
                        kahao: val.kahao
                    };
                    this.$emit("changeAccount", data);
                }
            });
        }
    }
}
</script>

<style scoped>
.wp {
    height: 85%;
    overflow: hidden;
}
.switchAccounts-wrapper {
    top: 0;
    left: 0;
    background: #eee;
    z-index: 500;
}
.title {
    height: 0.88rem;
    box-sizing: border-box;
    margin-bottom: 0.48rem;
    line-height: 0.9rem;
    font-size: .28rem;
    font-weight: 500;
    position: relative;
}
.cancel {
    left: .2rem;
    font-size: .5rem;
}
.switchAccounts-list-wrapper {
    height: 70%;
    overflow-y: scroll;
}
.switchAccounts-list {
    border-radius: .04rem;
    padding: .15rem;
    padding-right: 1.7rem;
}
.yes-img {
    top: 50%;
    right: .16rem;
    width: 1.44rem;
    height: 0.48rem;
    line-height: 0.48rem;
    border-radius: 12px;
    transform: translate(0, -50%);
}
.account-img {
    width: auto;
    height: 0.91rem;
    border-radius: .04rem;
    margin-right: 0.12rem;
}
.account-right {
    height: 1rem;
}
</style>